import DialogActions from '@mui/material/DialogActions';
import { ReactNode } from 'react';

interface PortalDialogActionsProps {
  children: ReactNode;
}

export function PortalDialogActions({ children }: PortalDialogActionsProps) {
  return <DialogActions>{children}</DialogActions>;
}
